import { css } from '@emotion/react'
import styled from '@emotion/styled'

const wrapperTitleStyles = ({ theme }) => css`
    margin-top: ${theme.spacings.giga};
    text-align: center;
`

export const WrapperTitle = styled('div')(wrapperTitleStyles)
